import { render } from "./TestBlock.vue?vue&type=template&id=67dcd4be"
import script from "./TestBlock.vue?vue&type=script&lang=js"
export * from "./TestBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__